import { Node } from 'slate';

export const EXPLANATIONS = 'explanations';
export const EXPLANATION = 'explanation';

export const PLUGIN_EXPLANATON_PRESENT_TYPES = {
  EXPLANATION: 'plugin-explanaton-explanation',
};

export type ExplanationsOptions = {
  isReadOnly?: boolean;
  [key: string]: any;
};

export type ExplanationsNode = {
  label: string;
  /** Need this in case need to add correctAnswer in side `serialize` function */
  parentNodeType?: string;
  /** Used to display in a Portal */
  portalId?: string;
} & Node;

export type ExplanationNode = {
  /** For any element has same id */
  forId: string;
} & Node;
